// extracted by mini-css-extract-plugin
export var box = "Box-module--box--XoLUI";
export var heading = "Box-module--heading--NSng-";
export var body = "Box-module--body---Q7L0";